/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const FrontendFieldDefinitionType = {
        INPUT: 'input',
        SELECT: 'select',
        CHECKBOX: 'checkbox',
        DATE: 'date',
        DOCUMENT_UPLOAD: 'document_upload',
        TEXT: 'text',
        GENERIC_INPUT: 'generic_input',
        GENERIC_DROPDOWN: 'generic_dropdown',
        TAX_IDENTIFICATION_NUMBERS: 'tax_identification_numbers',
        HIDDEN: 'hidden',
        EMBEDDED_RESOURCE: 'embedded_resource',
        LINK_BUTTON: 'link_button',
        GENERIC_CHECKBOX: 'generic_checkbox'
} as const;
export type FrontendFieldDefinitionType = typeof FrontendFieldDefinitionType[keyof typeof FrontendFieldDefinitionType];

